import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useOverrides } from "../context/OverridesContext";

/**
 * Refreshes the OverridesContext every time the route changes, so admin edits
 * made in /admin/content are reflected the next time an author lands on any
 * studio page. Also listens to a custom window event so an admin save can
 * broadcast to any open studio tab.
 */
export default function OverridesRefresher() {
  const location = useLocation();
  const { refresh } = useOverrides();

  useEffect(() => {
    refresh();
  }, [location.pathname, refresh]);

  useEffect(() => {
    const handler = () => refresh();
    window.addEventListener("authoros:overrides-updated", handler);
    return () => window.removeEventListener("authoros:overrides-updated", handler);
  }, [refresh]);

  return null;
}
